import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

const Loader: React.FC = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <Spinner animation="border" role="status" variant="primary">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );
};

export default Loader;
